<template>
  <option :value="10">10m</option>
  <option :value="25">25m</option>
  <option :value="50">50m</option>
  <option :value="75">75m</option>
  <option :value="100">100m</option>
</template>
